import React from 'react';
import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Modal, Space, Tooltip, message } from 'antd';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { PartnerType } from '../../../../types/benefit';
import { PARTNER } from '../../../../constants/define/translation';
import { deletePartnerRepository } from '../../../../repository/mytm/partner/partnerRepository';
import { btnActive } from '../../../../styles';
import { MESSAGE_ERROR } from '../../../../constants/message';
import { CONFIG_CONTAINER_NAME, deleteBlob } from '../../../../utils/azure';

interface ActionsColumnProps {
  record: PartnerType;
  setIsOpenModal: Function;
  setDataRecord: Function;
  onRefresh: () => void;
  total: number;
  handleChangePagePartner: Function;
}

export default React.memo((props: ActionsColumnProps) => {
  const { t } = useTranslation(PARTNER);
  const { record, setIsOpenModal, setDataRecord, onRefresh, total, handleChangePagePartner } = props;

  const handleDelete = async () => {
    Modal.confirm({
      title: t('table.popup.title'),
      okText: t('table.popup.okBtn'),
      cancelText: t('table.popup.cancelBtn'),
      icon: <ExclamationCircleOutlined />,
      content: t('table.popup.delete'),
      onOk() {
        deletePartnerRepository(record?.id)
          .then((res: any) => {
            if (res && res.success) {
              deleteBlob(record?.partnerBrandImageUrl, CONFIG_CONTAINER_NAME.UPLOADS).then().catch();
              message.success(t('message.success.deletePartner'));
            } else {
              modalError(res.message);
            }
          })
          .catch(() => message.error(MESSAGE_ERROR.M02))
          .finally(() => {
            const numRecord = total - 1;
            if (numRecord && numRecord > 0) {
              onRefresh();
            } else {
              handleChangePagePartner(1);
            }
          });
      },
    });
  };

  const modalError = (content: string) => {
    Modal.error({
      title: t('table.popup.titleErr'),
      okText: t('table.popup.okDone'),
      content,
    });
  };

  const handleEdit = () => {
    setIsOpenModal(true);
    setDataRecord(record);
  };

  return (
    <StyledContainer>
      <Space size="small">
        <Tooltip title={t('table.tooltip.edit')}>
          <Button icon={<EditOutlined />} onClick={handleEdit} />
        </Tooltip>
        <Tooltip title={t('table.tooltip.delete')}>
          <Button icon={<DeleteOutlined style={{ color: '#ff4d4f' }} />} onClick={handleDelete} />
        </Tooltip>
      </Space>
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0.5rem;
  ${btnActive}
`;
